class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.addListeners();
  }

  changeVariant(handle, variantId) {
    fetch(
      (window.routes.root_url != "/" ? window.routes.root_url : "") +
        "/products/" +
        handle +
        "?variant=" +
        variantId +
        "&section_id=product-card"
    )
      .then((response) => {
        return response.text();
      })
      .then((response) => {
        const html = new DOMParser().parseFromString(response, "text/html");
        //replace card media
        if (
          this.querySelector(".card__top") &&
          html.querySelector(".card__top")
        ) {
          this.querySelector(".card__top").innerHTML =
            html.querySelector(".card__top").innerHTML;
        }

        let isExpanded = false;
        if (
          this.querySelector(".card__swatches") &&
          this.querySelector(".card__swatches").classList.contains("expanded")
        ) {
          isExpanded = true;
        }

        //replace card content
        if (
          this.querySelector(".card__content") &&
          html.querySelector(".card__content")
        ) {
          this.querySelector(".card__content").innerHTML =
            html.querySelector(".card__content").innerHTML;

          if (this.querySelector(".card__swatches") && isExpanded) {
            this.querySelector(".card__swatches").classList.add("expanded");
          }
        }

        if (
          this.querySelector(".card__link") &&
          html.querySelector(".card__link")
        ) {
          this.querySelector(".card__link").href =
            html.querySelector(".card__link").href + "?variant=" + variantId;
        }

        this.addListeners();
        this.classList.remove("loading");
      })
      .catch((e) => {
        console.error(e);
        this.classList.remove("loading");
      });

    //change variant ID on add button
    if (this.querySelectorAll("add-product").length) {
      this.querySelectorAll("add-product").forEach((button) => {
        button.setAttribute("data-id", variantId);
      });
    }
  }

  addListeners() {
    this.colourSwatches = this.querySelectorAll(".js-colour-swatch");
    this.colourSwatchesArr = [...this.querySelectorAll(".js-colour-swatch")];
    let colourSwatchesSet = new Set(
      this.colourSwatchesArr.map((x) => x.getAttribute("data-color"))
    );
    let colourSwatchesCount = 0;

    this.colourSwatchesArr.forEach((swatch) => {
      let color = swatch.getAttribute("data-color");

      if (colourSwatchesSet.has(color)) {
        colourSwatchesSet.delete(color);
        colourSwatchesCount++;
      } else {
        swatch.style.display = "none";
      }
    });

    if (this.colourSwatches.length) {
      this.colourSwatches.forEach((swatch) => {
        swatch.addEventListener("click", (e) => {
          e.preventDefault();
          this.classList.add("loading");

          this.colourSwatches.forEach((allSwatches) => {
            allSwatches.classList.remove("active");
          });
          swatch.classList.add("active");

          const handle = swatch.getAttribute("data-product-handle");
          const variant = swatch.getAttribute("data-variant-id");

          if (handle && variant) {
            this.changeVariant(handle, variant);
          } else {
            this.classList.remove("loading");
          }
        });
      });
    }

    this.fakeVariantSelect = this.querySelector(".js-fake-variant-select");
    if (this.fakeVariantSelect) {
      this.fakeVariantSelect.addEventListener("change", (e) => {
        this.classList.add("loading");
        const productHandle = e.target.value;
        if (productHandle) {
          this.changeVariant(productHandle, null);
        }
      });
    }

    //Product card swatches
    this.swatchExpand = this.querySelectorAll(".js-swatches-toggle");
    if (this.swatchExpand.length) {
      this.swatchExpand.forEach((expand) => {
        expand.addEventListener("click", (e) => {
          e.preventDefault();
          expand.closest(".card__swatches").classList.add("expanded");
        });
      });
    }

    this.closeQuickAdd = this.querySelector(".js-close-quick-add");
    this.quickAdd = this.closest(".js-quick-add");
    if (this.closeQuickAdd && this.quickAdd) {
      this.closeQuickAdd.addEventListener("click", () => {
        this.quickAdd.dispatchEvent(new Event("close"));
      });
    }
  }
}

customElements.define("product-card", ProductCard);
